// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "专业英语",
      "tec": "李岱菊徐亮",
      "week": "1-11周",
      "add": "教学楼B座417能动"
    },
    0,
    0,
    {
      "sub": "人工智能",
      "tec": "任娜",
      "week": "1-10周",
      "add": "实训F座210信机"
    },
    0
  ],
  "2": [
    0,
    {
      "sub": "人机交互设计",
      "tec": "孟轩羽",
      "week": "1-11周",
      "add": "实训F座210信机"
    },
    0,
    {
      "sub": "虚拟现实应用系统开发",
      "tec": "王洪江",
      "week": "1-10周",
      "add": "新型电力系统大楼212计算机房"
    },
    {
      "sub": "虚拟现实应用系统开发",
      "tec": "王洪江",
      "week": "1-10周",
      "add": "新型电力系统大楼212计算机房"
    }
  ],
  "3": [
    {
      "sub": "专业英语",
      "tec": "李岱菊徐亮",
      "week": "1-11单周",
      "add": "教学楼B座222自控"
    },
    0,
    0,
    0,
    0
  ],
  "4": [
    0,
    {
      "sub": "人机交互设计",
      "tec": "孟轩羽",
      "week": "1-11周",
      "add": "实训F座210信机"
    },
    0,
    {
      "sub": "虚拟现实应用系统开发",
      "tec": "王洪江",
      "week": "1-10周",
      "add": "新型电力系统大楼212计算机房"
    },
    {
      "sub": "虚拟现实应用系统开发",
      "tec": "王洪江",
      "week": "1-10周",
      "add": "新型电力系统大楼212计算机房"
    }
  ],
  "5": [
    0,
    0,
    {
      "sub": "人工智能",
      "tec": "任娜",
      "week": "1-10双周",
      "add": "实训楼F座304信机"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
